<template>
  <div class="c-section grey detail-view-form-list-filters">
    <row>
      <column>
        <row>
          <column>

            <div class="container">
              <label for="submission-start-date-filter">Submission Date Start</label>
              <date-picker id="submission-start-date-filter"
                           v-model="submissionStartDate"
                           :mode="DatetimeMode.Date"
                           @input="triggerUpdate"
                           allow-input
                           :id="`form-list=${contentElement.client_id}-submission-start-date-filter`"></date-picker>
            </div>
          </column>
          <column>
            <div class="container">
              <label for="submission-end-date-filter">Submission Date End</label>
              <date-picker id="submission-end-date-filter"
                           v-model="submissionEndDate"
                           :mode="DatetimeMode.Date"
                           @input="triggerUpdate"
                           allow-input
                           :id="`form-list=${contentElement.client_id}-submission-end-date-filter`"></date-picker>
            </div>
          </column>
        </row>
      </column>
      <column>
        <row class="align-items-end">
          <column size="370">
            <div class="container">
              <label for="selected-form-a-select">Form</label>
              <a-select id="selected-form-a-select"
                        @input="triggerUpdate"
                        v-model="selectedFormId"
                        :options="linkedFormOptions"></a-select>
            </div>
          </column>
          <column class="align-right">
            <div class="container mb-3">
              <button type="button" class="btn blue" @click="clearFilters">Clear Filters</button>
            </div>
          </column>
        </row>
      </column>
    </row>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import DatePicker from "~/components/datePicker.vue";
  import FormList from "../../../formability/detailViewBuilder/models/formList";
  import {IVOptionSetLocal} from "~/interfaces/vSelectInterfaces";
  import {DatetimeMode} from "~/models/datetimeMode";
  import Selected from "../../../formability/detailViewBuilder/store/modules/selected";
  import organizationMixin from "~/mixins/organizationMixin";

  const AllForms = "ALL_FORMS"

  export default Vue.extend({
    components: {
      DatePicker
    },
    mixins: [organizationMixin],
    props: {
      contentElement: {
        type: Object as () => FormList
      },
      linkedForms: {
        type: Array as () => Array<{title: string, id: string}>
      }
    },
    data: function() {
      return {
        DatetimeMode,
        user: Selected.currentUser.get(),
        selectedFormId: AllForms,
        submissionStartDate: null,
        submissionEndDate: null,
      }
    },
    computed: {
      linkedFormOptions(): IVOptionSetLocal {
        const forms = this.linkedForms.map(lf => {
          return {
            label: lf.title,
            value: lf.id
          }
        })
        forms.unshift({
          label: "All Forms",
          value: AllForms
        })
        return {options: forms, selectedOption: forms.find(e => e.value === this.selectedFormId) };
      },
    },
    methods: {
      triggerUpdate() {
        this.$emit('handleFilters', {
          selectedFormId: this.selectedFormId !== AllForms ? this.selectedFormId : null,
          submissionStartDate: this.submissionStartDate,
          submissionEndDate: this.submissionEndDate,
        })
      },
      clearFilters() {
        this.selectedFormId = AllForms;
        this.submissionStartDate = null;
        this.submissionEndDate = null;
        this.triggerUpdate();
      }
    }

  })
</script>